// extracted by mini-css-extract-plugin
export var messageSideLeft = "_m3-1";
export var messageSideRight = "_m3-2";
export var subscribeToBackInStockBubbleContainer = "_m3-0";